export default __webpack_public_path__ + "static/media/ico_patient_profile.a9e67957.svg";